var commandKeyPressed = false;
$(document).keydown(function (e) {
    commandKeyPressed = e.keyCode === 91 || e.keyCode === 224; // Mac cmd key
});

// Make all teasers clickable
export default {
    makeClickable(selector = "") {
        $(`${selector} article.teaser`).each(function () {
            $(this).click(e => {
                // Avoid current window to go to clicked link AND to open a new tab if user press ctrl / cmd
                if(commandKeyPressed || e.ctrltKey) {
                    return;
                }

                if(this.className.indexOf("teaser--video-xl") !== -1) {
                    return;
                }

                let teaserLink = $(this).find("a:first");
                if(teaserLink.length > 0) {
                    e.stopPropagation();
                    if(teaserLink.attr('target') === "_blank") {
                        e.preventDefault();
                        window.open(teaserLink.attr("href"), '_blank');
                    } else {
                        window.location.href = teaserLink.attr("href");
                    }
                }
            });
        });
    }
}



// WEBPACK FOOTER //
// ./js/teasers/Teasers.js